import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { loginService } from "../../services/loginService";
import { ProgressSpinner } from 'primereact/progressspinner';
import { Ripple } from "primereact/ripple";
import { t } from "i18next";
import moment from "moment";
import { utils } from "../../utils";
interface LogoutModalProps {
    OnClose: () => void;
}

interface LogoutModalState {
    loader: boolean
}

export default class LogoutModal extends React.Component<LogoutModalProps, LogoutModalState> {
    constructor(props) {
        super(props);
        this.state = {
            loader: false,
        };
    }

    logout() {
        if (utils.isElectronBuild()) {
            var log = `[${moment().format("h:mm:ss DD/MM/YYYY")}] ---- method:logout manually}`;
            window.myAPI.LogoutLog(log);
        }

        this.setState({ loader: false })
        loginService.logout();
        this.props.OnClose()
        //    cookieService.removeElectronCookies('language');
    }

    render(): React.ReactNode {
        return (
            <div className="text-center">
                <Modal isOpen={true}>
                    <ModalHeader>{t("logoutComponent.header")}</ModalHeader>
                    <ModalBody>{t("logoutComponent.message")}</ModalBody>
                    <ModalFooter>
                        {this.state.loader ? (
                            <>
                                <ProgressSpinner
                                    style={{ height: "50px", width: "50px" }}
                                    strokeWidth="3"
                                    fill="#EEEEEE"
                                    animationDuration=".5s"
                                />
                            </>
                        ) : (
                            <>
                                <button className="wgbtn p-ripple" onClick={() => this.logout()}>
                                    <Ripple />{t("Yes")}
                                </button>
                                <button className="wgclear-btn p-ripple" onClick={() => this.props.OnClose()}>
                                    <Ripple />{t("No")}
                                </button>
                            </>
                        )}
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}